import { forwardRef, useImperativeHandle, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { ExploreCatalogCard as ExploreCatalogCardType } from '../../core/types/explore.types'
import ExploreCatalogCard from './explore-catalog-card'

type ExploreCatalogGridProps = {
  cards: ExploreCatalogCardType[]
  onScroll: () => void
  onSelectCard: (card: ExploreCatalogCardType) => void
}

export type ExploreCatalogGridHandle = {
  stageRef: HTMLDivElement | null
}

const useStyles = makeStyles(() => ({
  stage: {
    position: 'relative',
    minHeight: 0,
    flex: 1,
    overflowY: 'auto',
    paddingTop: 8,
    paddingRight: 4,
    // Hide scrollbar
    scrollbarWidth: 'none' as const,
    msOverflowStyle: 'none' as const,
    '&::-webkit-scrollbar': { display: 'none' },
  },
  grid: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 12,
    paddingBottom: 8,
  },
}))

const ExploreCatalogGrid = forwardRef<ExploreCatalogGridHandle, ExploreCatalogGridProps>(
  ({ cards, onScroll, onSelectCard }, ref) => {
    const classes = useStyles()
    const stageRef = useRef<HTMLDivElement | null>(null)

    useImperativeHandle(ref, () => ({
      get stageRef() {
        return stageRef.current
      },
    }))

    return (
      <div
        ref={stageRef}
        className={classes.stage}
        onScroll={onScroll}
      >
        <div className={classes.grid}>
          {cards.map((card, index) => (
            <ExploreCatalogCard
              key={card.id}
              card={card}
              cardIndex={index}
              onSelect={onSelectCard}
            />
          ))}
        </div>
      </div>
    )
  }
)

ExploreCatalogGrid.displayName = 'ExploreCatalogGrid'

export default ExploreCatalogGrid
